// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React, { useEffect } from 'react';
import { app, authentication } from '@microsoft/teams-js';
import styles from './SignInPage.module.scss';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import { useSearchParams } from 'react-router';
import { getStoredRelativeUrl } from '../../utils/storage';
import { Button, Text } from '@fluentui/react-components';

const SignInPage = () => {
    const { t } = useTranslation();
    const message = t('SignInPromptMessage');
    const [searchParams] = useSearchParams();

    useEffect(() => {
        app.notifySuccess();
    }, []);

    const onSignIn = () => {
        const state = searchParams.get('state') ?? '';

        const authenticatePopUpParameters: authentication.AuthenticatePopUpParameters =
            {
                url:
                    window.location.origin +
                    `/signin-simple-start?state=${decodeURIComponent(state)}`,
            };

        authentication
            .authenticate(authenticatePopUpParameters)
            .then((authState) => {
                let relativeUrl = authState
                    ? getStoredRelativeUrl(authState) || '/'
                    : '/';

                // /<segment>/<guid - optional || id - number>
                // example: /users/123e4567-e89b-12d3-a456-426614174000
                // example: /users
                // example: /errorpage/403
                if (!/^\/[a-zA-Z0-9]+(\/[a-zA-Z0-9-]+)?$/.test(relativeUrl)) {
                    relativeUrl = '/';
                }

                window.location.assign(relativeUrl);
            })
            .catch((error: string) => {
                console.log('Login failed: ' + error);
                window.location.href = `/errorpage?error=${decodeURIComponent(
                    error
                )}&locale=${i18n.language}`;
            });
    };

    return (
        <div className={styles.signInContentContainer}>
            <Text>{message}</Text>
            <div className={styles.space}></div>
            <Button
                appearance="primary"
                className={styles.signInButton}
                onClick={onSignIn}
            >
                {t('SignIn')}
            </Button>
        </div>
    );
};

export default SignInPage;
